//@flow
import { LocusApiModel } from 'common/modules/api';

export const chatLogin: LocusApiModel = new LocusApiModel({
    endPoint: '/client/{clientId}/personnel/{personnelId}/chat-login'
});

export const contactSearch: LocusApiModel = new LocusApiModel({
    endPoint: '/client/{clientId}/personnel/{personnelId}/chat-contact-search'
});
